import { render } from "./NewContract.vue?vue&type=template&id=3f8ece88"
import script from "./NewContract.vue?vue&type=script&lang=js"
export * from "./NewContract.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projects/inqi/inqi-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__